import { sendMessage, constructAddSelectionPayload } from "../lib/postMessage";

const initState = {
  selections: [],
  format: "Fractional",
};

const betslip = (state = initState, action) => {
  switch (action.type) {
    case "ADD_SELECTION_TO_BETSLIP":
      const msg = {
        type: "AddSelections",
        payload: {
          location: action.payload.location || "Results",
          selections: [constructAddSelectionPayload(action.payload.bet)],
        },
      };
      sendMessage(msg);
      return {
        ...state,
        selections: [
          ...state.selections,
          { id: action.payload.id, marketId: action.payload.marketId },
        ],
      };

    case "REMOVE_SELECTION_FROM_BETSLIP": {
      const newSelections = [
        ...state.selections.filter(
          (selection) =>
            selection.id !== action.payload.id ||
            selection.marketId !== action.payload.marketId
        ),
      ];
      const msg = {
        type: "RemoveSelections",
        payload: {
          location: action.payload.location || "Results",
          selections: [
            {
              selectionId: action.payload.id,
              marketId: action.payload.marketId,
            },
          ],
        },
      };
      sendMessage(msg);
      return {
        ...state,
        selections: newSelections,
      };
    }

    case "REMOVE_SELECTIONS_FROM_BETSLIP": {
      const newSelections = [
        ...state.selections.filter((sel) => {
          return action.payload.selections?.every((fil) => {
            return sel.id !== fil.id || sel.marketId !== fil.marketId;
          });
        }),
      ];

      const formatted =
        action.payload.selections?.map((sel) => ({
          selectionId: sel.id,
          marketId: sel.marketId,
        })) || [];

      const msg = {
        type: "RemoveSelections",
        payload: {
          location: action.payload.location || "Results",
          selections: formatted,
        },
      };
      sendMessage(msg);
      return {
        ...state,
        selections: newSelections,
      };
    }

    case "ADD_ALL_SELECTIONS_TO_BETSLIP": {
      // remove duplicates
      const newSelections = action.payload.selections?.filter((newSel) => {
        return !state.selections.some(
          (sel) => newSel.id === sel.id && newSel.marketId === sel.marketId
        );
      });

      const msg = {
        type: "AddSelections",
        payload: {
          location: action.payload.location || "Results",
          selections: newSelections.map((sel) => {
            return constructAddSelectionPayload(sel.bet);
          }),
        },
      };

      sendMessage(msg);
      return {
        ...state,
        selections: [
          ...state.selections,
          ...newSelections.map((sel) => {
            return { id: sel.id, marketId: sel.marketId };
          }),
        ],
      };
    }

    // INCOMING POST MESSAGES FROM THE PARENT

    case "BetslipRemoveSelections": {
      const newSelections = [
        ...state.selections.filter((sel) => {
          return action.payload.selections?.every((fil) => {
            return sel.id !== fil.selectionId || sel.marketId !== fil.marketId;
          });
        }),
      ];

      return {
        ...state,
        selections: newSelections,
      };
    }

    case "BetslipAddSelections": {
      // when the iframe is loaded in prod, this event is triggered
      // to sync up the selections that are possibly in the betslip
      // with the iframe. But if the selections are empty, it means
      // there's no selections, potentially because a bet has just been
      // made, so we want to always clear the filters to reset the
      // iframe to its default state if there's no selections
      if (action.payload.selections?.length === 0) {
        localStorage.setItem("filters", JSON.stringify({}));
      }

      const newSelections = action.payload.selections?.filter((newSel) => {
        return !state.selections.some(
          (sel) =>
            newSel.selectionId === sel.id && newSel.marketId === sel.marketId
        );
      });

      const formatted =
        newSelections?.map((sel) => ({
          id: sel.selectionId,
          marketId: sel.marketId,
        })) || [];

      return {
        ...state,
        selections: [...state.selections, ...formatted],
      };
    }

    case "BetslipClear":
      return {
        ...state,
        selections: [],
      };

    case "OddsFormat":
      return {
        ...state,
        format:
          action.payload.format === "Decimal" ||
          action.payload.format === "Fractional"
            ? action.payload.format
            : "Fractional",
      };

    default:
      return state;
  }
};

export default betslip;
